import Header from './EmployeesListHeader';
import Filters from './EmployeesListFilters';
import Table from './EmployeesListTable';
import Row from './EmployeesListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/list/index.js